import { useMutation } from '@tanstack/react-query';

import { deleteUserLeaveBoard } from '../requests';
import type { DeleteUserLeaveBoardRequest } from '../types';

export const useDeleteUserLeaveBoard = () =>
  useMutation({
    mutationFn: (params: DeleteUserLeaveBoardRequest) =>
      deleteUserLeaveBoard(params),
  });
